import React, { useEffect } from 'react';
import Table from '../../../components/Table.tsx';
import FormActions from '../../../components/form/FormActions.tsx';
import FormButton from '../../../components/form/FormButton.tsx';
import FormInput from '../../../components/form/FormInput.tsx';
import { useJournalNamesContext } from '../../../contexts/journalNames/journalNames.tsx';
import { JournalName } from '../../../models/JournalName.ts';
import IsNullOrEmpty from '../../../models/helpers/isNullOrEmpty.ts';

const JournalNamesBody = () => {
    const { journalNames, updateJournalNames } = useJournalNamesContext();
    const [localJournalNames, setLocalJournalNames] = React.useState(journalNames);
    useEffect(() => {
        setLocalJournalNames(journalNames);
    }, [journalNames]);
    const columns = [
        {
            header: "name",
            name: "name",
            cell: (props: any) => {
                const journalName = props.row;
                return (
                    <FormInput
                        entity={props.row}
                        handleInputChange={(e: any) => handleInputChange(e, journalName)}
                        fieldName='name'
                        showLabel={false}
                        mb={0}
                    />
                );
            }
        },
        {
            header: "order",
            name: "orderID",
            cell: (props: any) => {
                const journalName = props.row;
                return (
                    <div className="d-flex flex-column">
                        <FormButton
                            onClick={() => handleChangeOrder(journalName, true)}
                            icon='arrow-up'
                            color='secondary'
                            className={"list-group-top"}
                        />
                        <FormButton
                            onClick={() => handleChangeOrder(journalName, false)}
                            icon='arrow-down'
                            color='secondary'
                            className={"list-group-bottom"}
                        />
                    </div>
                );
            }
        },
    ]
    const handleInputChange = (e: any, entity: JournalName) => {
        const { value } = e.target;

        const updatedJournalNames = [...localJournalNames];

        updatedJournalNames.find(jn => jn.orderID == entity.orderID)!.name = value;

        setLocalJournalNames(updatedJournalNames);
    };
    const handleChangeOrder = (entity: JournalName, moveUp: boolean) => {
        if ((entity.orderID == 1 && moveUp) ||
            (entity.orderID == localJournalNames.length && !moveUp)) return;

        const updatedJournalNames = [...localJournalNames];

        const originalPosition = entity.orderID;
        const desiredPosition = entity.orderID + (moveUp ? -1 : 1);

        if (moveUp == false) {
            updatedJournalNames.find(jn => jn.orderID == desiredPosition)!.orderID = originalPosition;
            updatedJournalNames.find(jn => jn.orderID == originalPosition)!.orderID = desiredPosition;
        }
        else {
            updatedJournalNames.find(jn => jn.orderID == originalPosition)!.orderID = desiredPosition;
            updatedJournalNames.find(jn => jn.orderID == desiredPosition)!.orderID = originalPosition;
        }

        updatedJournalNames.sort((a, b) => a.orderID - b.orderID);

        setLocalJournalNames(updatedJournalNames);
    };
    const handleAddItem = () => {
        const updatedJournalNames = [...localJournalNames];
        updatedJournalNames.push({ orderID: localJournalNames.length + 1 } as JournalName);
        setLocalJournalNames(updatedJournalNames);
    }

    return (
        <>
            <Table columns={columns} rows={localJournalNames} />
            {localJournalNames.length < 10 &&
                <FormButton
                    text='Add'
                    onClick={handleAddItem}
                    color='success'
                    className='w-100'
                />
            }
            <small className="text-muted">
                Empty values will be deleted from the list.
            </small>
            <FormActions
                mainAction={() => updateJournalNames(localJournalNames.filter(jn => !IsNullOrEmpty(jn.name)))}
                mainActionText="Save"
            />
        </>
    );
};

export default JournalNamesBody;
